import { ProfileCard } from 'types/profile';
import { Link } from 'types/api.types';
import { Time } from 'types/general.types';

export enum SplitMemberStatus {
  ACCEPTED = 'ACCEPTED',
  PROPOSED = 'PROPOSED',
}

export type Member = {
  memberIdentifier: string;
  profileCard?: ProfileCard;
  profile?: ProfileCard;
  share?: string | number;
  status?: SplitMemberStatus;
  ipi?: string;
  roles?: string[];
  valid?: boolean;
};

export type SplitShares = {
  members: {
    memberIdentifier: string;
    share: string;
  }[];
};

export type LatestSplit = {
  created: Time;
  updated: Time;
  members: Member[];
  sequenceNumber: number;
  songGuid: string;
  valid: boolean;
  hasNewCredits?: boolean;
  createdBy: {
    userGuid: string;
    profileCard: ProfileCard;
  };
  _links?: {
    self: Link;
    acceptWorkSplit?: Link;
    getLatestWorkSplit?: Link;
    getLatestWorkSplitPdf?: Link;
  };
};
